export const API_URL = process.env.VUE_APP_API ? process.env.VUE_APP_API : 'https://homecare-api.howdesign.com.tw';

export const test = '';
